import React from 'react';
import styles from './IconSkeleton.module.css';

const IconSkeleton = ({
    width = '100px',
    height = '50px',
    className = '',
    show = true
}) => {
    if (!show) return null;

    return (
        <div
            className={`${styles.skeleton} ${className}`}
            style={{ width, height }}
        >
            <div className={styles.shimmer}></div>
        </div>
    );
};

export default IconSkeleton;
